<template><div></div></template>

<script>
export default {
  name: 'GoogleRegistration',
  data () {
    return {
      googleToken: {
        code: null
      }
    }
  },
  created () {
    this.googleToken.code = this.$route.query.code
  },
  mounted () {
    this.lockScreen()
    this.$store.dispatch('getGoogleLoginUrl', this.googleToken)
      .then(() => {
        this.$router.push({ name: 'dashboard' })
      })
      .catch(() => {
        this.$router.push({ name: 'login' })
      })
  }
}
</script>
